import { Box, Paper, Grid, Typography } from "@mui/material";
import Attribute from "./Attribute";
import Gauge from "../Gauge";
import APIMetrics from "../../types/APIMetrics";
import APIRiskAnalysis from "../../types/APIRiskAnalysis";

export default function Firmographics({
  opengraphImageLink,
  foundedYear,
  metrics,
  summary,
  formationType,
  riskAnalysis,
}: {
  opengraphImageLink: string | null;
  foundedYear: number | null;
  metrics: APIMetrics | null;
  summary: string | null;
  formationType: string | null;
  riskAnalysis: APIRiskAnalysis | null;
}) {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 0,
        overflow: "hidden",
      }}
    >
      {opengraphImageLink && (
        <Box
          sx={{
            height: "fit-content",
            maxHeight: 150,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: "-10%",
              right: "-10%",
              bottom: "10%",
              top: "-10%",
              zIndex: 1,
              display: "block",
              backgroundSize: "cover",
              backgroundImage: `url('${opengraphImageLink}')`,
              backgroundPosition: "center center",
              filter: "blur(35px)",
            }}
          />

          <img
            style={{
              position: "relative",
              zIndex: 2,
              maxWidth: "100%",
              maxHeight: 150,
              display: "block",
              margin: "auto",
              background: "#fff",
            }}
            src={opengraphImageLink}
            alt="Opengraph"
          />
        </Box>
      )}

      <Box
        sx={{
          p: 3,
        }}
      >
        <Typography variant="h6" component="h3" sx={{ fontWeight: "normal" }}>
          Profile
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Grid
            container
            spacing={2}
            columnSpacing={{ xs: 2, md: 6 }}
            rowSpacing={{ xs: 2, md: 0 }}
            sx={{
              marginTop: 1,
            }}
          >
            <Grid size={12}>
              <Attribute label="Summary">
                {summary || "No description"}
              </Attribute>
            </Grid>

            <Grid size={6}>
              <Attribute label="Year founded">{foundedYear}</Attribute>
            </Grid>

            <Grid size={6}>
              <Attribute label="Estimated annual revenue">
                {metrics?.estimated_annual_revenue_range}
              </Attribute>
            </Grid>

            <Grid size={6}>
              <Attribute label="Estimated employee count">
                {metrics?.estimated_employee_count_range}
              </Attribute>
            </Grid>

            <Grid size={6}>
              <Attribute label="Formation type">{formationType}</Attribute>
            </Grid>
            {riskAnalysis?.fraud_risk && (
              <Grid size={6}>
                <Attribute label="Likelihood of fraudulent behavior in the next 6&nbsp;months">
                  <Box
                    sx={{
                      mt: 3,
                      alignItems: "flex-start",
                      display: "flex",
                    }}
                  >
                    <Gauge
                      severity={
                        riskAnalysis.fraud_risk === "HIGH"
                          ? "poor"
                          : riskAnalysis.fraud_risk === "MEDIUM"
                            ? "fair"
                            : riskAnalysis.fraud_risk === "LOW"
                              ? "good"
                              : "fair"
                      }
                      ordering="worst-last"
                      label={riskAnalysis.fraud_risk}
                    />
                  </Box>
                </Attribute>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Paper>
  );
}
